import CheckedIcon from '@mui/icons-material/CheckBox';
import UncheckedIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { Autocomplete, Checkbox, Chip, Stack, TextField, Typography } from '@mui/material';
import useFlexBoxStyles from 'common/flexBox';
import { useMemo } from 'react';
import useStylesLabels from './styles/useStylesLabels.styles';

const SelectChipsInputUsers = (props) => {
    const { selectedOptions, onChange, readOnly, placeholder, optionsRender, size } = props;
    const { classes, cx } = useStylesLabels();
    const { classes: flexBox } = useFlexBoxStyles();

    const updateLabels = (_e, labels) => {
        onChange(labels);
    };

    let rootClass = classes.root;
    if (size === 'small') {
        rootClass = cx(rootClass, classes.sizeSmall);
    }
    if (size === 'medium') {
        rootClass = cx(rootClass, classes.sizeMedium);
    }

    const [options, optionsHash] = useMemo(() => {
        const hash = optionsRender?.reduce((hash, user) => (hash[user.id] = user) && hash, {});
        return hash ? [Object.keys(hash), hash] : [[], {}];
    }, [optionsRender]);

    return (
        <Autocomplete
            // limitTags={limitTags || -1}
            className={rootClass}
            disableCloseOnSelect
            multiple
            classes={{
                option: classes.option,
                listbox: classes.listBox,
            }}
            readOnly={readOnly}
            options={options}
            value={selectedOptions}
            filterOptions={(options, state) =>
                options.filter((option) => {
                    const user = optionsHash[option];
                    return (
                        user &&
                        (user?.fullName.toLowerCase().trim().includes(state.inputValue.toLowerCase().trim()) ||
                            user?.firstName.toLowerCase().trim().includes(state.inputValue.toLowerCase().trim()) ||
                            user?.lastName.toLowerCase().trim().includes(state.inputValue.toLowerCase().trim()) ||
                            user?.email.toLowerCase().trim().includes(state.inputValue.toLowerCase().trim()))
                    );
                })
            }
            renderTags={(value, getTagProps) =>
                value.map((option, index) => {
                    const user = optionsHash[option];
                    return <Chip key={index} variant="outlined" label={user?.fullName} {...getTagProps({ index })} />;
                })
            }
            renderOption={(props, option, { selected }) => {
                const user = optionsHash[option];
                return (
                    <li {...props} key={option}>
                        <Checkbox
                            icon={<UncheckedIcon fontSize="small" />}
                            checkedIcon={<CheckedIcon fontSize="small" />}
                            className={flexBox.marginRight1}
                            checked={selected}
                        />
                        <Stack direction="row" spacing={2} alignItems="center">
                            <Typography fontWeight={500}>{user?.fullName}</Typography>
                            <Typography variant="body2" fontWeight={500}>
                                {user?.email}
                            </Typography>
                        </Stack>
                    </li>
                );
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    variant="outlined"
                    placeholder={selectedOptions.length ? '' : placeholder}
                    required
                />
            )}
            onChange={updateLabels}
            autoCorrect="false"
        />
    );
};

export default SelectChipsInputUsers;
